import { ZfIconButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { PreselectedRelationshipType } from '../../types/PartnerRelation';

const addIconOffset = -35;

type AddIconSide = 'top' | 'bottom' | 'left' | 'right';

const addIconRelationshipTypeMap: Record<AddIconSide, PreselectedRelationshipType> = {
    top: PreselectedRelationshipType.IS_CHILD,
    bottom: PreselectedRelationshipType.IS_PARENT,
    right: PreselectedRelationshipType.IS_SPOUSE,
    left: PreselectedRelationshipType.IS_SPOUSE,
};

interface IPartnerNodeAddIconsProps {
    usedSides: Record<AddIconSide, boolean>;
    onAddIconClick: (relationshipType: PreselectedRelationshipType) => void;
}

export const PartnerNodeAddIcons: FunctionComponent<IPartnerNodeAddIconsProps> = ({ usedSides, onAddIconClick }) => (
    <>
        <ZfIconButton
            icon={'add_circle'}
            hierarchy={'tertiary'}
            size="medium"
            onClick={() => onAddIconClick(addIconRelationshipTypeMap.top)}
            style={{
                position: 'absolute',
                top: addIconOffset,
                left: usedSides.top ? '65%' : '50%',
                transform: 'translateX(-50%)',
            }}
        />
        <ZfIconButton
            icon={'add_circle'}
            hierarchy={'tertiary'}
            size="medium"
            onClick={() => onAddIconClick(addIconRelationshipTypeMap.left)}
            style={{
                position: 'absolute',
                top: usedSides.left ? '40%' : '50%',
                left: addIconOffset,
                transform: 'translateY(-50%)',
            }}
        />
        <ZfIconButton
            icon={'add_circle'}
            hierarchy={'tertiary'}
            size="medium"
            onClick={() => onAddIconClick(addIconRelationshipTypeMap.right)}
            style={{
                position: 'absolute',
                top: usedSides.right ? '40%' : '50%',
                right: addIconOffset,
                transform: 'translateY(-50%)',
            }}
        />
        <ZfIconButton
            icon={'add_circle'}
            hierarchy={'tertiary'}
            size="medium"
            onClick={() => onAddIconClick(addIconRelationshipTypeMap.bottom)}
            style={{
                position: 'absolute',
                bottom: addIconOffset,
                left: usedSides.bottom ? '65%' : '50%',
                transform: 'translateX(-50%)',
            }}
        />
    </>
);
